
$(".custom-carousel").owlCarousel({
  autoWidth: true,
  loop: true,
  dots: false,
  mouseDrag: false,
});


$(document).ready(function () {
  // Au chargement de la page, ajoutez la classe lg-hotspot--visible aux hotspots de la carte active
  $(".custom-carousel .item.active .lg-hotspot").addClass("lg-hotspot--visible");

  $(".custom-carousel .item").click(function () {
    // Stockez une référence à la carte cliquée
    var $clickedCard = $(this);

    // Vérifiez si la carte cliquée est déjà ouverte
    if ($clickedCard.hasClass("active")) {
      // Si elle est ouverte, fermez-la
      $clickedCard.removeClass("active");
      // Cachez les hotspots de la carte cliquée
      $clickedCard.find(".lg-hotspot").removeClass("lg-hotspot--visible");
    } else {
      // Si elle n'est pas ouverte, fermez toutes les cartes ouvertes
      $(".custom-carousel .item.active").removeClass("active");
      // Ouvrez la carte cliquée
      $clickedCard.addClass("active");

      // Cachez tous les labels des hotspots
      $(".lg-hotspot").removeClass("lg-hotspot--visible");

      // Ajoutez un délai avant d'afficher les hotspots
      setTimeout(function () {
        // Affichez le label du hotspot de la carte cliquée
        $clickedCard.find(".lg-hotspot").addClass("lg-hotspot--visible");
      }, 500); // 500 millisecondes (ajustez cette valeur selon vos préférences)
    }
  });
});
















































